<template>
  
  <div class="1">
    <div class="title-icon"><i>大模型开发工具Function Call的原理及实践</i></div>
    <div class="main-content">
      <div class="block">原理及作用</div>
      <div class="block">简单应用</div>
      <div class="block">构造方法</div>
      <div class="block">基于ChatGPT模型实现Function Call的实践应用</div>
      <div class="block" style="white-space:nowrap;">国产大模型ChatGLM3-6B模型实践Function Call功能</div>
    </div>
    <div class="title-icon"><i>GPTs与Assistant API</i></div>
    <div class="main-content">
      <div class="block">GPTS功能应用</div>
      <div class="block">Assistant API的功能原理讲解</div>
      <div class="block block2" style="margin-right: 0;">财务助手实战项目</div>
    </div>
    <div class="title-icon"><i>大模型Agent的原理及实践</i></div>
    <div class="main-content">
      <div class="block">定义及功能</div>
      <div class="block">Agent架构设计</div>
      <div class="block">Agent开发实践</div>
    </div>
  </div>       
</template>

<script>
import pageTitle from "../../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  
  methods: {
    openDetail() {
      
    },
    
  },
};
</script>

<style lang="less" scoped>
@import "index.less";

</style>